module.exports = __webpack_public_path__ + "img/rule_text.370de24c.jpg";